export enum SUPPLIER_STATUS {
  Pendente = 'pendente',
  Aprovado = 'aprovado'
}

export type SupplierType = {
  _id: string;
  tradingName: string;
  companyName: string;
  status: SUPPLIER_STATUS;
  updatedAt: Date;
  createdAt: Date;
};

export type Observation = {
  text: string;
  date: string;
  author: string;
};

export type ISupplier = {
  _id: string;
  tradingName: string;
  companyName: string;
  supplierEmail: string;
  cnpj: string;
  workContact: ComnplementType;
  operationalContact: ComnplementType;
  observations: Observation[];
  createdAt: Date;
  updatedAt: Date;
}

type ComnplementType = {
  name: string;
  phone: string;
};

export const emptySupplier = () => ({
  _id: "",
  tradingName: "",
  companyName: "",
  supplierEmail: "",
  cnpj: "",
  workContact: {
    name: "",
    phone: "",
  },
  operationalContact: {
    name: "",
    phone: "",
  },
  observations: [],
  createdAt: new Date(),
  updatedAt: new Date(),
}) as ISupplier;